export const navigationData = {
  logo: {
    src: "/AEPL_lOGO.svg",
    alt: "AEPL",
    fullName: "Anugraha Exceed Pvt Ltd",
  },
  navItems: [
    {
      label: "Industries",
      path: "/industries",
      children: [
        {
          group: "Aviation",
          path: "/industries/aviation",
          items: [
            { label: "Flight Deck", path: "/industries/aviation/flight-deck" },
            { label: "Engineers", path: "/industries/aviation/engineers" },
            { label: "Cabin Crew", path: "/industries/aviation/cabin-crew" },
          ],
        },
        {
          group: "Defence",
          path: "/industries/defence",
          items: [
            { label: "Air Force", path: "/industries/defence/air-force" },
            { label: "Navy", path: "/industries/defence/navy" },
            { label: "Army", path: "/industries/defence/army" },
            {
              label: "Special Operations",
              path: "/industries/defence/special-operations",
            },
          ],
        },
        {
          group: "Energy",
          path: "/industries/energy",
          items: [
            { label: "Oil & Gas", path: "/industries/energy" },
            { label: "Nuclear (coming)", path: "#", disabled: true },
            { label: "Power & Utilities (coming)", path: "#", disabled: true },
            { label: "Renewables (coming)", path: "#", disabled: true },
          ],
        },
      ],
    },
    {
      label: "Platform",
      path: "/#platforms",
      children: [
        { label: "RAPTOR", path: "/product/raptor" },
        { label: "LearnOn", path: "/product/learnon" },
        { label: "Aurora", path: "/product/aurora" },
        { label: "GRIFFIN XR", path: "/product/griffin" },
        { label: "CourseAI", path: "/product/courseai" },
      ],
    },
    {
      label: "About Us",
      path: "/about",
      children: [
        { label: "The Idea", path: "/about/the-idea" },
        { label: "Quest", path: "/about/quest" },
        // { label: "Leadership", path: "/about/leadership" },
      ],
    },
  ],
  cta: {
    label: "Request a Walkthrough",
  },
};
